import { EFavoritesActionType, IFavoriteParameters } from './types';
import { decrementHeaderFavorites } from './utils/updateHeaderFavorites';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const favoriteRemove = actionGenerator<EFavoritesActionType.Removed, IFavoriteParameters>(EFavoritesActionType.Removed);

export function deleteFavorite(offerId: number): TThunkAction<Promise<void>> {
  return async dispatch => {
    dispatch(favoriteRemove({ offerId }));
    decrementHeaderFavorites();
  };
}
